var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_vm._m(0),_c('Counter',{attrs:{"msg":"Welcome to Your Vue.js App"}})],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-center mt-5 position-absolute f-logo"},[_c('img',{attrs:{"src":require("./assets/logo-dc.svg"),"width":"100%"}})])
}]

export { render, staticRenderFns }